export enum ReportType {
  DEVICE = 'device',
  DEVICE_DETAIL = 'deviceDetail',
  ALARM = 'alarm',
  MEASUREMENT = 'measurement',
  LOG = 'log',
  SIGI = 'sigi'
}

export enum ReportExportFormat {
  CSV = 'text/csv',
  PDF = 'application/pdf',
}

export enum ReportSteps {
  SELECT_REPORT_TYPE = 1,
  SELECT_TIME,
  SELECT_ELEMENTS,
  FILTER_ELEMENTS,
  SELECT_FORMAT,
  SELECT_COLUMNS,
  DOWNLOAD_REPORT,
}

export enum ReportGenerationStep {
  INITIALIZING = 'INITIALIZING',
  COLLECTING_DATA = 'COLLECTING_DATA',
  EXPORTING_FILE = 'EXPORTING_FILE',
  SAVING = 'SAVING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}